import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { store } from '@/store'
import router from './router'
import Vuex from 'vuex'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'es6-promise/auto'
import VueCarousel from 'vue-carousel';
import 'moment/locale/de'
import QrcodeVue from 'qrcode.vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import MessageCenter from './views/components/MessageCenter'
import fullscreen from 'vue-fullscreen'
import VueNumber from 'vue-number-animation'

Vue.use(fullscreen)
Vue.component('message-center', MessageCenter)

Vue.use(VueFormWizard);
Vue.use(VueCarousel);

Vue.directive('click-outside', {
  bind () {
      this.event = event => this.vm.$emit(this.expression, event)
      this.el.addEventListener('click', this.stopProp)
      document.body.addEventListener('click', this.event)
  },   
  unbind() {
    this.el.removeEventListener('click', this.stopProp)
    document.body.removeEventListener('click', this.event)
  },

  stopProp(event) { event.stopPropagation() }
})

import { library } from '@fortawesome/fontawesome-svg-core'
import { faLaptopHouse ,faHamburger, faVolumeUp, faChevronUp, faChevronDown, faInfoCircle, faMobile, faCreditCard, faMoneyBillWave, faUtensils, faChartLine, faFileAlt, faShoppingCart, faMapMarkedAlt, faChevronRight, faTimes, faEdit, faPrint, faBars, faColumns, faHouseUser, faArrowRight, faPlus, faBuilding, faEnvelope, faPaperPlane, faStar, faSortDown, faSortUp, faCircle, faBookmark, faComment, faPhone, faCog, faFilter, faUserTimes, faUserPlus, faUserCheck} from '@fortawesome/free-solid-svg-icons'
import { faCcPaypal, faCcVisa, faFacebookSquare, faTwitter, faWhatsapp, faInstagram, faWordpress} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './registerServiceWorker'

library.add(faUserCheck, faUserPlus, faUserTimes, faLaptopHouse ,faHamburger, faVolumeUp, faChevronUp, faChevronDown, faInfoCircle, faMobile, faCreditCard, faCcPaypal, faCcVisa, faMoneyBillWave, faUtensils, faChartLine, faFileAlt, faShoppingCart, faMapMarkedAlt, faChevronRight, faTimes, faEdit, faCog, faFilter, faPrint, faBars, faColumns, faHouseUser, faArrowRight, faPlus, faBuilding, faEnvelope, faFacebookSquare, faPaperPlane, faTwitter, faWhatsapp, faSortUp, faSortDown, faStar, faCircle, faBookmark, faComment, faInstagram, faWordpress, faPhone)

const moment = require('moment')
require('moment/locale/de')
 
Vue.use(require('vue-moment'), {
    moment
})

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueNumber)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  console.log(to)
  if(to.path == '/'){
    next()
  }else if(to.path == '/register'){
    next()
  }else if(to.name == 'Resetpassword'){
    next()
  }else if(to.path == '/datenschutz'){
    next()
  }else if(to.path == '/impressum'){
    next()
  }else if(to.path == '/agb'){
    next()
  }else if(to.name == "register" && to.params){
    next()
  }else{
    if((!localStorage.getItem('token')) && to.path !== `/login`){
      next(`/`)
    }else{
      next()
    }
  }

})

new Vue({
  router,
  store,
  components: {
    QrcodeVue,
  },
  render: h => h(App)
}).$mount('#app')
